import {
  getAmplitudeSessionId,
  hasAmplitudeConsent,
} from './amplitudeSession.ts';

const ANALYTICS_SESSION_ID_HEADER = 'sorare-analytics-session-id';

export const getAnalyticsHeaders = (): Record<string, string> => {
  if (typeof window === 'undefined' || !hasAmplitudeConsent()) return {};
  const sessionId = getAmplitudeSessionId();
  return Number.isSafeInteger(sessionId) && sessionId > 0
    ? { [ANALYTICS_SESSION_ID_HEADER]: String(sessionId) }
    : {};
};
